// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

// ── Upload─────────────────────────────────────────────────────────
export const ACCEPT_MAP = {
  csv: {
    label: 'CSV',
    ext: /\.csv$/i,
    accept: '.csv',
    mimes: [
      'text/csv',
      'application/vnd.ms-excel',
      'application/csv',
      'text/plain',
    ],
  },
  pdf: {
    label: 'PDF',
    ext: /\.pdf$/i,
    accept: 'application/pdf,.pdf',
    mimes: ['application/pdf'],
  },
  xls: {
    label: 'Excel (.xls)',
    ext: /\.xls$/i,
    accept: '.xls,application/vnd.ms-excel',
    mimes: ['application/vnd.ms-excel', 'application/octet-stream'],
  },
};

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

// ── Auth ──────────────────────────────────────────────────────────
export const TOKEN_KEYS = {
  ACCESS: 'access_token',
  REFRESH: 'refresh_token',
};

// ── Transaction types ─────────────────────────────────────────────
export const TRANSACTION_TYPES = ['INCOME', 'EXPENSE', 'SAVING', 'TRANSFER'];

export const SUMMARY_OPTIONS = {
  MONTH: 'Month',
  YEAR: 'Year',
  DATE: 'Date',
};

// ── Recurrence ────────────────────────────────────────────────────
export const DURATION_OPTIONS = ['DAYS', 'WEEKS', 'MONTHS', 'YEARS'];

// ── Feed / import ─────────────────────────────────────────────────
export const FEED_ROW_STATUSES = [
  'PENDING',
  'APPROVED',
  'SKIPPED',
  'COMMITTED',
  'DUPLICATE',
  'ERROR',
];

export const SUPPORTED_BANKS = [
  'HDFC',
  'ICICI',
  'SBI',
  'AXIS',
  'KOTAK',
  'GENERIC',
];

export const MAX_FILE_SIZE_MB = 10;

// ── Alert types ───────────────────────────────────────────────────
export const ALERT_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
};

// ── Category fallback options (used before API loads) ─────────────
// Categories now come from the API — these are fallback seed labels only
export const EXPENSE_CATEGORIES = [
  'Rent',
  'Repairs',
  'Utilities',
  'Groceries',
  'Transportation',
  'Snacks',
  'Electricity',
  'Water',
  'Internet',
  'Phone',
  'Movies',
  'Games',
  'Subscriptions',
  'Events',
  'Medicines',
  'Personal',
  'Vacation and Fun',
  'Fast Food',
  'Casual Dining',
  'Fine Dining',
  'Insurance',
  'Taxes',
  'Loans',
  'Gifts & Donations',
  'Education',
  'Misc',
];

export const INCOME_CATEGORIES = [
  'Salary',
  'Bonus',
  'Dividends',
  'Interest',
  'Gifts',
  'Refunds',
  'Meal Card',
  'Others',
];

export const SAVING_CATEGORIES = [
  'Fixed Deposit',
  'Recurring Deposit',
  'Mutual Funds',
  'Stocks',
  'RSU',
  'Retirement',
  'Gold',
  'Real Estate',
  'Crypto',
  'Parents',
  'Others',
];

export const PAYMENT_MODES = [
  'Cash',
  'ICICI Credit Card',
  'Axis Credit Card',
  'SBI Credit Card',
  'Debit Card',
  'UPI',
  'Meal Card',
  'Net Banking',
  'Others',
];

// ── Category emoji icons ──────────────────────────────────────────
export const CATEGORY_ICONS = {
  food: '🍽️',
  groceries: '🍽️',
  snacks: '🍿',
  'fast food': '🍔',
  'casual dining': '🍽️',
  'fine dining': '🍷',
  transport: '🚗',
  transportation: '🚗',
  entertainment: '🎬',
  movies: '🎬',
  games: '🎮',
  subscriptions: '📺',
  shopping: '🛍️',
  health: '🏥',
  medical: '🏥',
  medicines: '💊',
  utilities: '⚡',
  electricity: '⚡',
  water: '💧',
  internet: '🌐',
  phone: '📱',
  salary: '💰',
  bonus: '🎁',
  savings: '🏦',
  investment: '📈',
  'mutual funds': '📊',
  stocks: '📈',
  gold: '🥇',
  transfer: '🔄',
  rent: '🏠',
  education: '📚',
  insurance: '🛡️',
  taxes: '🧾',
  loans: '💳',
  misc: '📦',
};

// ── Type colors (Tailwind classes) ────────────────────────────────
export const TYPE_STYLES = {
  INCOME: {
    active: 'bg-green-600 text-white border-green-600',
    inactive: 'bg-green-50 text-green-700 border-green-200 hover:bg-green-100',
    text: 'text-green-600',
    bg: 'bg-green-100',
  },
  EXPENSE: {
    active: 'bg-red-600 text-white border-red-600',
    inactive: 'bg-red-50 text-red-600 border-red-200 hover:bg-red-100',
    text: 'text-red-600',
    bg: 'bg-red-100',
  },
  SAVING: {
    active: 'bg-blue-600 text-white border-blue-600',
    inactive: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
    text: 'text-blue-600',
    bg: 'bg-blue-100',
  },
  TRANSFER: {
    active: 'bg-amber-500 text-white border-amber-500',
    inactive: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100',
    text: 'text-amber-600',
    bg: 'bg-amber-100',
  },
};
